import { UpdateIndividualPerson } from "../../Models/IndividualPerson";
import api from "../axios";

export const individualPersonService = {
  update: async (individualPerson: UpdateIndividualPerson): Promise<boolean> => {
    const response = await api.patch('/individual-person', individualPerson);
    return response.data;
  },

  updateDocument: async (id: string, data: { cpf: string }): Promise<boolean> => {
    const response = await api.patch(`/individual-person/${id}/document`, data);
    return response.data;
  }
};
